import { withInstall } from '@unpack-ui/utils'
import Card from './src/card.vue'

export const UCard = withInstall(Card)

export * from './src/card'

export default UCard
